import { useEffect } from "react";
import { useAiImageStore } from "../store";

export const useResetStore = () => {
  const reset = useAiImageStore((s) => s.reset);

  useEffect(() => {
    return () => {
      reset();
    };
  }, []);
};
